/** Only a transaction identifier survives the sheet; no element or member data is retained. */
let requestedTransactionId: number | undefined;

export function requestTransactionListFocus(id: number): void {
  requestedTransactionId = Number.isSafeInteger(id) && id > 0 ? id : undefined;
}

/** Called by the visible list after its data is ready. Hidden sheet backgrounds opt out. */
export function restoreTransactionListFocus(): void {
  if (requestedTransactionId === undefined || typeof document === "undefined") return;
  const row = document.querySelector<HTMLButtonElement>(`.member-transaction-management__row[data-transaction-id="${requestedTransactionId}"]`);
  const destination = row ?? document.querySelector<HTMLHeadingElement>(".member-transaction-management__heading h1");
  if (!destination) return;
  requestedTransactionId = undefined;
  destination.focus({ preventScroll: true });
}
